import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function markTest(information) {
	return fetch(
		`${ENDPOINT_URL}/marktest`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(information),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
